import U from './lib-utils';


const MUL = {
    'B': 1,
    'K': 1024,
    'M': 1024 * 1024,
    'G': 1024 * 1024 * 1024,
    'T': 1024 * 1024 * 1024 * 1024,
    'P': 1024 * 1024 * 1024 * 1024 * 1024
};

const BAD_INPUT = 'input is not memSize compatible';
const BAD_INPUT_RX = 'input is not memSize view like 0-9{1,}[B*|K|M|G|T|P]';
const BAD_MUL = 'unknown multiplier. only B*|K|M|G|T|P are allowed';


function getMulValue(x) {
    if ('string' === (typeof x)) {
        let ux = x.toUpperCase();
        if (Object.prototype.hasOwnProperty.call(MUL, ux)) {
            if ('number' === (typeof MUL[ux])) {
                return MUL[ux];
            }
        }
    }
    return null;
}

function mulExists(x) {
    return null !== getMulValue(x);
}

function normMul(x) {
    if ('string' === (typeof x)) {
        let ux = x.toUpperCase();
        if (Object.prototype.hasOwnProperty.call(MUL, ux)) {
            if ('number' === (typeof MUL[ux])) {
                return ux;
            }
        }
    }
    return null;
}




function MSR() {
    return (MSR.is(this) ? this.init : MSR.F).apply(this, Array.prototype.slice.call(arguments));
}


let P = U.fixup_constructor(MSR).prototype;

P.value = null;
P.mult = null;
P.error = null;


P.init = function (v) {
    try {
        let x = parseMemSize(v);
        this.value = x[0];
        this.mult = x[1];
    } catch (e) {
        this.value = null;
        this.mult = null;
        this.error = e.message;
    }
    return this;
};

P.isValid = function () {
    return null === this.error && null !== this.value && null !== this.mult;
};

P.is_valid = P.isValid;

P.toString = function () {
    if (null === this.error) {
        return [this.value, this.mult].join('');
    }
    return null;
};

P.to_string = P.toString;

P.toInt = function () {
    return this.value * getMulValue(this.mult);
};

P.to_int = P.toInt;
P.toBytes = P.toInt;
P.to_bytes = P.toInt;


function parseMemSize(x) {
    let v = null;
    if ('number' === (typeof x)) {
        let k = U.IntMoreOr(x, 0, null);
        if (null !== k) {
            v = [k, 'B'].join('');
        }
    }
    if ('string' === (typeof x)) {
        v = U.NEString(x, null);
    }
    if (null !== v) {
        let m = /^(\d{1,})([a-z]{1}){0,1}$/i.exec(v);
        if (m) {
            let value = U.intMoreOr(m[1], 0, null);
            let mod = normMul(U.NEString(m[2], 'b'));
            if (null === mod) {
                throw new Error(BAD_MUL);
            }
            if (null === value) {
                throw new Error(BAD_INPUT_RX);
            }
            return [value, mod];
        } else {
            throw new Error(BAD_INPUT_RX);
        }
    }
    throw new Error(BAD_INPUT);
}

function normMemSize(x) {
    let a = parseMemSize(x);
    return a.join('');
}


export {parseMemSize, normMemSize, MSR, normMul, getMulValue, mulExists };


